import type { ListingDoc, SupraLockboxDoc } from '@bb/domain/dist/schemas';
import type { JsonObject, Override } from '@bb/domain/dist/types';
import type { SupraCoopType } from '@bb/domain/dist/types/SupraSystemSubscription';
import type { IMLSNumbers } from '@bb/users';
import axios from 'axios';

export type AccessHoursTimeRange = {
  startTime: number;
  endTime: number;
};

type LockboxAccessHoursIBoxResponse = {
  monday2Friday?: AccessHoursTimeRange;
  saturday?: AccessHoursTimeRange;
  sunday?: AccessHoursTimeRange;
};

type LockboxAccessHoursInvoyResponse = {
  monday?: AccessHoursTimeRange;
  tuesday?: AccessHoursTimeRange;
  wednesday?: AccessHoursTimeRange;
  thursday?: AccessHoursTimeRange;
  friday?: AccessHoursTimeRange;
  saturday?: AccessHoursTimeRange;
  sunday?: AccessHoursTimeRange;
};

// @TODO: Move to @/app-package
export type ParsedSupraLockboxJsonType = JsonObject<
  Override<
    SupraLockboxDoc,
    {
      parsedOwner?: {
        name: string;
        type: string;
        // Additional fields if org/branch/user
        logo?: string;
        // Additional fields if branch/user
        orgId?: string;
        // Additional fields if branch
        id?: string;
        orgName?: string;
        // Additional fields if user
        firstName?: string;
        lastName?: string;
        mlsNumbers?: IMLSNumbers[];
        branchName?: string;
        teams?: string[];
        location?: string;
        coopType?: SupraCoopType;
        // Additional fields if office
        address?: string;
      };
      parsedAssignee?: {
        name: string;
        logo: string;
        type: string;
        // Additional fields if branch/user
        orgId?: string;
        // Additional fields if branch
        id?: string;
        orgName?: string[];
        // Additional fields if user
        firstName?: string;
        lastName?: string;
        mlsNumbers?: IMLSNumbers[];
        branchName?: string;
        teams?: string[];
        location?: string;
        coopType?: SupraCoopType;
        // Additional fields if office
        address?: string;
      };
      listing: Pick<
        ListingDoc,
        'line1' | 'line2' | 'thumbnail' | 'city' | 'province'
      >;
      productCode?: 'iBox' | 'invoy' | 'iBox BTLE';
      accessHours?:
        | LockboxAccessHoursIBoxResponse
        | LockboxAccessHoursInvoyResponse
        | null;
    }
  >
>;

const getSupraLockboxData = async (id: string) => {
  const { data } = await axios.get<ParsedSupraLockboxJsonType>(
    `/supra/lockbox/${id}`,
  );

  return data;
};

export default getSupraLockboxData;
